import Vue from 'vue'
Vue.filter("formatDate", function formatDate(value) {
  var date = new Date(value);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
  return year + "-" + month + "-" + day;
});
Vue.filter("formatDateTime", function formatDateTime(value) {
  var date = new Date(value);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
});

Vue.filter("formatLandingTime", function formatLandingTime(value) {
  let landingtime = 0;
  let sec = value;
  let min = Math.floor(sec / 60);
  if (min < 1) {
      landingtime = sec % 60 + "秒";
  } else if (min < 60) {
      landingtime = min + "分" + sec % 60 + "秒";
  } else {
      landingtime = Math.floor(min/60) + "小时" + min%60 + "分" + sec % 60 + "秒";
  }
  return landingtime;
});

